import img1 from '../assets/png/img1.jpeg';
import img2 from '../assets/png/img2.jpeg';
import img3 from '../assets/png/img3.jpeg';
export const achievementData = {
    bio : "Innovative software engineer with extensive experience in developing Web applications, Mobile Applications, Posters, leading complex projects, and implementing effective solutions. Renowned for delivering high-quality code and fostering collaboration within cross-functional teams. Recognized for exceptional problem-solving skills and a strong commitment to continuous improvement.",
    achievements : [
        {
            id : 1,
            title : 'Web Developnment(MERN Stack)',
            details : 'Achieved 1st position in a comprehensive MERN stack course, demonstrating exceptional proficiency in MongoDB, Express.js, React, and Node.js.',
            date : 'Sept , 2023',
            field : 'Developnment',
            image : img1
        },
        {
            id : 2,
            title : 'Graphic Designing(UI/UX Design)',
            details : 'Completed a graphic designing (UI/UX) course, mastering skills in user interface and user experience design to create intuitive and visually appealing digital products.',
            date : 'Aug, 2022',
            field : 'Designing',
            image : img2
        },
        {
            id : 3,
            title : 'web Developnment',
            details : 'Completed a comprehensive web development course, gaining expertise in front-end and back-end technologies to build dynamic and responsive websites and applications.',
            date : 'May, 2022',
            field : 'Automation',
            image : img3
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/